"use strict";
function phoneNumberValidator() {
    return function (control) {
        var value = control.value;
        // todo: fix with masking or better regex
        var pattern = /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/;
        if (value && value !== '' && !pattern.test(value)) {
            return { 'invalid': true };
        }
        return null;
    };
}
exports.phoneNumberValidator = phoneNumberValidator;



// WEBPACK FOOTER //
// ./~/@bhtp-client-web/component/src/validators/phone-number.validator.js